module.exports = __webpack_public_path__ + "static/media/co-logo@3x.3a805d17.png";